export const constructEmbedLocalStorageKey = ({
  origin,
  graphRef,
}: {
  origin: string;
  graphRef?: string;
}) => {
  return `${origin}:${graphRef}`;
};
